'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.superstruct = twentyninetimes.superstruct || function () {

	function init() {
    // check if body has class
    if (!document.body.classList.contains('has-superstruct')) 
      return;

    

    const newsletterBtn = document.querySelectorAll('.is-style-sso-newsletter-toggle');
		const initSSO = function(context, { brand, element }) { 
      if (typeof controller == 'undefined') 
        return;
      
      // Import the controller
      controller.setConfig({
        element,
        flow: 'directFlow', 
        brand, 
        showBenefits: false
      });

      controller
        .checkForActiveSession()
        .then(response => {
          console.log('userData:', response.data.data);
        })
        .catch(error => { 
          console.log(error.response.data);
      });
      
      // Newsletter signup
      if ( newsletterBtn ) {
        newsletterBtn.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();

            controller.newsLetterSignup();
          });
        });
      }
    };

    // Init SSO
    const brand = 'tinderbox'; // Brand name
    const element = document.querySelector('.site'); // Element to append the SSO to
    if (element) {
      initSSO(document, { brand, element });
    }
	}

	return {
		init : init
	};

}();